import {Box} from "@mui/material";
import AuthBanner from "./AuthBanner";
import * as React from "react";
import ResetPasswordForm from "./ResetPasswordForm";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useTrackScreenVisit} from "crqlar-react-common/dist/utils/analytics.util";

interface Props {
}

const ResetPasswordScreen = ({}: Props) => {

    useTrackScreenVisit('reset-password')
    const {t} = useTranslation();

    return <Box
        sx={{
            display: 'flex',
            position: 'relative',
        }}
    >
        <Box sx={{
            position: 'absolute',
            top: "12px",
            right: "12px"
        }}>
            <Button
                component={Link}
                to="/identity/login"
                variant="text"
                size="small"
            >
                {t("Login")}
            </Button>
        </Box>

        <AuthBanner/>

        <Box sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            boxShadow: '0 0 10px 0 rgba(0,0,0,0.1)'
        }}>
            <ResetPasswordForm/>
        </Box>
    </Box>
};


export default ResetPasswordScreen
